export default __webpack_public_path__ + "static/media/unmatch-vehicle-white.02423030.svg";